import { render, staticRenderFns } from "./m-orm-table.vue?vue&type=template&id=30849254&lang=pug&"
import script from "./m-orm-table.vue?vue&type=script&lang=js&"
export * from "./m-orm-table.vue?vue&type=script&lang=js&"
import style0 from "./m-orm-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VDataTable,VRow,VSelect})
